<div class="container-profil">
  <ng-container *ngIf="loaded">
    <ng-container *ngIf="imgName; else noImg">
      <img [src]="imgUrl" />
    </ng-container>
    <ng-template #noImg>

      <ng-container *ngIf="type==='MALE'">
        <img src="assets/images/silhouette_homme.svg" />
      </ng-container>
      <ng-container *ngIf="type==='FEMALE'">
        <img src="assets/images/silhouette_femme.svg" />
      </ng-container>

      <ng-container *ngIf="type==='CLI'">
        <img src="assets/images/Profil.png" />
      </ng-container>

      <ng-container *ngIf="!type">
        Pas d'image
      </ng-container>
    </ng-template>
  </ng-container>


  <div class="link">
    <a [ngClass]="{'disabled' : !linkFacebook}" href="{{linkFacebook}}" class="button" target="_blank"><i class="fab fa-facebook-f"></i></a>
    <a [ngClass]="{'disabled' : !linkTwitter}" href="{{linkTwitter}}" class="button" target="_blank"><i class="fab fa-x-twitter"></i></a>
    <a [ngClass]="{'disabled' : !linkLinkedIn}" href="{{linkLinkedIn}}" class="button" target="_blank"><i class="fab fa-linkedin-in"></i></a>
    <a [ngClass]="{'disabled' : !linkViadeo}" href="{{linkViadeo}}" class="button" target="_blank"><i class="fab fa-viadeo"></i></a>
  </div>
</div>
